<template>
  <div>
    <keep-alive>
      <router-view v-if="keepAlive" :key="$route.path" />
    </keep-alive>
    <router-view v-if="!keepAlive" :key="$route.path" />
    <!-- <keep-alive :include="keepAliveListIncludeNames">
      <router-view :key="$route.path" />
    </keep-alive> -->
  </div>
</template>

<script>

export default {
  name: 'PageView',
  computed: {
    keepAliveListIncludeNames() {
      return this.$store.getters.keepAliveListIncludeNames
    },
    keepAlive() {
      return this.$route.meta.keepAlive
    }
  }
}
</script>
